import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {CoreActionTypes, SelectOrganization, SelectOrganizationFail, SelectOrganizationSuccess} from '../actions/core.actions';
import {map, withLatestFrom} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import * as fromAfbApi from '../../afb-api/reducers';
import * as fromAfbGraphqlApi from '../../afb-graphql-api/reducers';
import {SelectedOrganizationRequest} from '../models/core';
import {Organization} from '../../afb-graphql-api/models/organization';

@Injectable()
export class CoreEffects {

  @Effect()
  selectOrganization$ = this.actions$.pipe(
    ofType(CoreActionTypes.SelectOrganization),
    map((action: SelectOrganization) => action.payload),
    withLatestFrom(
      this.afbGraphqlApiState$.pipe(select(fromAfbGraphqlApi.organizationEntities)),
      this.afbApiState$.pipe(select(fromAfbApi.organizationTokenEntities))
    ),
    map(([selectedOrganizationRequest, organizationEntities, organizationTokenEntities]:
           [SelectedOrganizationRequest, { [id: string]: Organization }, { [id: string]: string }]) => {
        const organizationId: string = selectedOrganizationRequest.organizationId;

        if (organizationEntities[organizationId] && organizationTokenEntities[organizationId]) {
          const organizationWithToken = {
            ...organizationEntities[organizationId],
            token: organizationTokenEntities[organizationId]
          };
          localStorage.setItem('selected_organization', JSON.stringify(organizationWithToken));
          return new SelectOrganizationSuccess(organizationWithToken);
        } else {
          return new SelectOrganizationFail(`Selected organization doesn't exist.`);
        }
      }
    )
  );

  constructor(private actions$: Actions,
              private afbApiState$: Store<fromAfbApi.State>,
              private afbGraphqlApiState$: Store<fromAfbGraphqlApi.State>) {
  }
}
